<img class="logo zero-state-image"
	[alt]="spotLogo.alt"
	[src]="spotLogo.src"
	[style.width]="width"
	[style.height]="height"/>
